export default "__VITE_ASSET__X4tN$jYF__"